/* BeenieBae Theme — theme.js */

/* ── MOBILE NAV ── */
function toggleMobileNav() {
  const nav = document.getElementById('bbMobileNav');
  if (nav) nav.classList.toggle('open');
}

/* ── NOTIFY MODAL ── */
function openNotify() {
  const overlay = document.getElementById('bbNotifyOverlay');
  if (overlay) { overlay.classList.add('active'); document.body.style.overflow = 'hidden'; }
}
function closeNotify() {
  const overlay = document.getElementById('bbNotifyOverlay');
  if (overlay) { overlay.classList.remove('active'); document.body.style.overflow = ''; }
}
function submitNotify() {
  const email = document.getElementById('notifyEmail');
  if (!email || !email.value.includes('@')) { if(email) email.focus(); return; }
  document.getElementById('bbNotifyForm').style.display = 'none';
  document.getElementById('bbNotifyConfirm').style.display = 'block';
}

/* ── ACCORDION ── */
function toggleAcc(id) {
  const item = document.getElementById(id);
  if (!item) return;
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.bb-acc-item').forEach(i => {
    i.classList.remove('open');
    const icon = i.querySelector('.bb-acc-icon');
    if (icon) icon.textContent = '+';
    const trigger = i.querySelector('.bb-acc-trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  });
  if (!isOpen) {
    item.classList.add('open');
    const icon = item.querySelector('.bb-acc-icon');
    if (icon) icon.textContent = '−';
    const trigger = item.querySelector('.bb-acc-trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }
}

/* ── CLOSE MODALS ON OVERLAY CLICK ── */
document.addEventListener('click', function(e) {
  const notifyOverlay = document.getElementById('bbNotifyOverlay');
  if (notifyOverlay && e.target === notifyOverlay) closeNotify();
  const reserveOverlay = document.getElementById('bbReserveOverlay');
  if (reserveOverlay && e.target === reserveOverlay) closeReserve();
});

/* ── ESC KEY ── */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') { closeNotify(); if(typeof closeReserve === 'function') closeReserve(); }
});
